'use client';

import { useTranslations } from 'next-intl';
import { SettingsSection } from '../../settings/SettingsSection';
import {
  DnsZoneAttachSection,
  type DnsZoneAttachSectionProps,
} from './DnsZoneAttachSection';

export type DnsZonesSettingsSectionProps = DnsZoneAttachSectionProps;

export function DnsZonesSettingsSection(props: DnsZonesSettingsSectionProps) {
  const t = useTranslations(
    'designSystem.networkSettings.externalInventory.dnsZones',
  );

  return (
    <SettingsSection title={t('title')} description={t('description')}>
      <DnsZoneAttachSection {...props} />
    </SettingsSection>
  );
}
